import { useEffect, useState } from 'react';
import { Head, HeadWrapper, TabsWrapper, Wrapper } from './approval-manager-page.styles';
import { TabManagerApproveValues } from '../config/ui-constants';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { Typography } from '@shared/ui/typography/typography';
import { SegmantTabs } from '@shared/ui/segment-tabs/segment-tabs';
import { ListApprovalManagerOrders } from '@widgets/list-approval-manager-orders/ui/list-approval-manager-orders';
import { useOrdersListSharedQuery } from '@entities/order/libs/hooks/use-orders-list-shared-query/use-orders-list-shared-query';
import { useRequestsListSharedQuery } from '@entities/request/libs/hooks/use-request-list-shared-query/use-request-list-shared-query';
import { DEFAULT_REQUESTS_LIST_PARAMETERS } from '@entities/request/config/store-constants';
import { DEFAULT_ORDERS_LIST_PARAMETERS } from '@entities/order/config/store-constants';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { tabs } from '@pages/approval-manager-page/lib/utils/tabs';
import { ListApprovalManagerRequest } from '@widgets/list-approval-manager-requests/ui/list-approval-manager-requests';
import { RequestsListDataRequest } from '@entities/request/api/request-types';
import { OrdersListDataRequest } from '@entities/order/api/order-types';
import { ModalOrderDetailedInfo } from '@widgets/modal-order-detailed-info/modal-order-detailed-info';
import { FilterApprovalOrders } from '@features/order/filter-approval-orders/ui/filter-approval-orders';
import { FilterApprovalRequests } from '@features/request/filter-approval-requests/ui/filter-approval-requests';
import { SortApprovalRequests } from '@features/request/sort-approval-requests/ui/sort-approval-requests';
import { SortOrders } from '@features/order/sort-orders/ui/sort-orders';
import { useUrlTabs } from '@shared/lib/hooks/use-url-tabs/use-url-tabs';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const ApprovalManagerPage = () => {
    const user = useCurrentUserSelector();
    const history = useHistory();
    const companyId = user?.company?.id || 0;
    const [ordersParameters, setOrdersParameters] = useSearchParams<OrdersListDataRequest>({
        ...DEFAULT_ORDERS_LIST_PARAMETERS,
        companyIds: companyId ? [companyId] : [],
    });
    const [requestsParameters, setRequestsParameters] = useSearchParams<RequestsListDataRequest>({
        ...DEFAULT_REQUESTS_LIST_PARAMETERS,
        companyId,
    });

    const [getOrders, getOrdersResult] = useOrdersListSharedQuery(ordersParameters);
    const [getRequests, getRequestsResult] = useRequestsListSharedQuery(requestsParameters);
    const tabsList = tabs({
        orderCount: getOrdersResult.data?.total,
        requestCount: getRequestsResult.data?.total,
    });

    const { tabValue, handleSetTabValue } = useUrlTabs({
        tabValues: Object.values(TabManagerApproveValues),
        initialTabValue: TabManagerApproveValues.Orders,
    });

    const [orderCardId, setOrderCardId] = useState<number>();

    useEffect(() => {
        getOrders(ordersParameters);
    }, [ordersParameters]);

    useEffect(() => {
        getRequests(requestsParameters);
    }, [requestsParameters]);

    const handleClickOrderCardId = (id: number) => {
        setOrderCardId(id);
    };

    return (
        <>
            <Wrapper>
                <HeadWrapper>
                    <Head>
                        {Boolean(history.length) && (
                            <Button
                                round
                                size='xl'
                                buttonType='secondary'
                                startAdornment={<ArrowsChevronLeft />}
                                onClick={() => history.goBack()}
                            />
                        )}
                        <Typography size='h6'>Согласование</Typography>
                        {tabValue === TabManagerApproveValues.Orders && (
                            <FilterApprovalOrders
                                ordersParameters={ordersParameters}
                                setOrdersParameters={setOrdersParameters}
                            />
                        )}
                        {tabValue === TabManagerApproveValues.Requests && (
                            <FilterApprovalRequests
                                requestsParameters={requestsParameters}
                                setRequestsParameters={setRequestsParameters}
                            />
                        )}
                    </Head>
                    <TabsWrapper>
                        <SegmantTabs activeTabValue={tabValue} list={tabsList} onChange={handleSetTabValue} />
                    </TabsWrapper>
                    {tabValue === TabManagerApproveValues.Requests && (
                        <SortApprovalRequests parameters={requestsParameters} setParameters={setRequestsParameters} />
                    )}
                    {tabValue === TabManagerApproveValues.Orders && (
                        <SortOrders parameters={ordersParameters} setParameters={setOrdersParameters} />
                    )}
                </HeadWrapper>
                {tabValue === TabManagerApproveValues.Orders && (
                    <ListApprovalManagerOrders
                        ordersParameters={ordersParameters}
                        setOrdersParameters={setOrdersParameters}
                        onClickOrderCard={handleClickOrderCardId}
                    />
                )}
                {tabValue === TabManagerApproveValues.Requests && (
                    <ListApprovalManagerRequest
                        requestsParameters={requestsParameters}
                        setRequestsParameters={setRequestsParameters}
                    />
                )}
            </Wrapper>
            <ModalOrderDetailedInfo
                isShow={Boolean(orderCardId)}
                orderId={orderCardId}
                onClose={() => setOrderCardId(undefined)}
            />
        </>
    );
};
